/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { bignumberDependencies } from './dependenciesBignumber.generated.js';
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { combinationsDependencies } from './dependenciesCombinations.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { factorialDependencies } from './dependenciesFactorial.generated.js';
import { isIntegerDependencies } from './dependenciesIsInteger.generated.js';
import { isNegativeDependencies } from './dependenciesIsNegative.generated.js';
import { largerDependencies } from './dependenciesLarger.generated.js';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated.js';
import { numberDependencies } from './dependenciesNumber.generated.js';
import { powDependencies } from './dependenciesPow.generated.js';
import { subtractScalarDependencies } from './dependenciesSubtractScalar.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createStirlingS2 } from '../../factoriesAny.js';
export var stirlingS2Dependencies = {
  bignumberDependencies,
  addScalarDependencies,
  combinationsDependencies,
  divideScalarDependencies,
  factorialDependencies,
  isIntegerDependencies,
  isNegativeDependencies,
  largerDependencies,
  multiplyScalarDependencies,
  numberDependencies,
  powDependencies,
  subtractScalarDependencies,
  typedDependencies,
  createStirlingS2
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesStirlingS2.generated.js
// module id = sR/L
// module chunks = 3